const intervalWeights = [0.10, 0.30, 0.20, 0.15, 0.15, 0.025, 0.025, 0.05];

export default intervalWeights;